import React from "react";
import FileIcon from "../icons/FileIcon";

const FileMessage = (props) => {
  const { data, fileName, creationDate, displayName } = props;
  return (
    <>
      <span
        className="sc-message--file"
        onClick={() => window.open(data.url)}
        download={data.url}
      >
        <FileIcon />
        <p>{data.fileName}</p>
        <div>
          {" "}
          <span className="date-line d-flex" />
          <div className="date-name-display">
            {creationDate} {displayName}
          </div>
        </div>
      </span>
    </>
  );
};

export default FileMessage;
